import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./Toast.css";
import { useTranslation } from "../redux/TranslationHelper";
import { Provider } from "react-redux";
import store from "../redux/store";

// 토스트 컴포넌트 - 화면 중앙에 메시지 표시
const Toast = ({ message, type = "error", duration = 3000, onClose }) => {
  const [visible, setVisible] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => {
        if (onClose) onClose();
      }, 300); // 애니메이션 완료 후 DOM에서 제거
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  // 메시지가 문자열인 경우 번역 처리
  const translatedMessage = typeof message === 'string' ? t(message) : message;

  return (
    <div className={`toast-overlay ${visible ? "visible" : "hidden"}`}>
      <div className={`toast-container ${type} ${visible ? "visible" : "hidden"}`}>
        <div className="toast-content">
          <div className="toast-icon">
            {type === "error" && <i className="fas fa-exclamation-circle"></i>}
            {type === "success" && <i className="fas fa-check-circle"></i>}
            {type === "warning" && <i className="fas fa-exclamation-triangle"></i>}
            {type === "info" && <i className="fas fa-info-circle"></i>}
          </div>
          <div className="toast-message">{translatedMessage}</div>
        </div>
      </div>
    </div>
  );
};

// TranslationHelper를 사용하기 위한 래퍼 컴포넌트
const TranslatedToast = (props) => {
  return <Toast {...props} />;
};

// 토스트 관리자 - 토스트 표시를 위한 함수 제공
const toastContainer = document.createElement("div");
toastContainer.id = "toast-container-root";
document.body.appendChild(toastContainer);

let toastId = 0;
const toasts = [];

// 토스트 표시 함수
export const showToast = (message, type = "error", duration = 3000) => {
  const id = ++toastId;
  const handleClose = () => {
    const index = toasts.findIndex(toast => toast.id === id);
    if (index !== -1) {
      toasts.splice(index, 1);
      renderToasts();
    }
  };

  const toast = { id, message, type, duration, handleClose };
  toasts.push(toast);
  renderToasts();

  return id;
};

// 토스트 제거 함수
export const hideToast = (id) => {
  const index = toasts.findIndex(toast => toast.id === id);
  if (index !== -1) {
    toasts.splice(index, 1);
    renderToasts();
  }
};

// 토스트 렌더링 함수
const renderToasts = () => {
  ReactDOM.render(
    <Provider store={store}>
      <>
        {toasts.map(toast => (
          <TranslatedToast
            key={toast.id}
            message={toast.message}
            type={toast.type}
            duration={toast.duration}
            onClose={toast.handleClose}
          />
        ))}
      </>
    </Provider>,
    toastContainer
  );
};

export default Toast; 